<!-- eslint-disable vue/require-v-for-key -->
<template>
  <div>
    <b-navbar class="navbar">
      <div style="display: flex; flex-direction: row; align-items: center;">
        <span class="logo">
          <b-img
            :src="appLogoImage"
            alt="logo"
          />
        </span>
        <span class="x">X</span>
        <span class="logo2">
          <b-img
            src="https://www.ttl.fi/themes/custom/ttl/images/logo_fi.svg"
            alt="logo"
          />
        </span>
      </div>
      <locale />
    </b-navbar>
    <div style="display: flex; flex-direction: column; padding-top: 3vh; padding-bottom: 12vh;">
      <h1 id="title" class="title" style="text-align: center; align-self: center;">{{ title }}</h1>
      <div id="introContainer" class="introContainer">
        <span class="introText">
          <h4 style="margin-bottom: 2vh;">Yleistä tuberkuloosista ja lisätietoja</h4>
          <p style="line-height: 1.8rem; font-size: 1.1rem;">Tuberkuloosi on bakteerin aiheuttama sairaus, joka todetaan useimmin keuhkoissa. Tauti
            tarttuu ihmisestä toiseen hengitysilman mukana. Ilman hoitoa sairaus voi edetä vaikeaksi
            ja johtaa kuolemaan. Taudin leviämisen ehkäisy on tärkeää, sillä etenkin pienet lapset voivat
            sairastua vakavasti. Suomessa tuberkuloosin tutkimukset, hoito ja lääkkeet ovat tutkittavalle
            ilmaisia.
            <br><br>
            Tuberkuloosi voi tarttua, kun oleskellaan sisätiloissa. Tuberkuloositaudin varhainen toteaminen
            ja sairastuneiden hyvä hoito estää taudin tarttumista muihin ihmisiin. Samalla edistetään
            lähipiirin hyvinvointia ja ylläpidetään työntekijöiden työkykyä.
            Suomessa tartuntatautilaki (55§) määrää, että työnantajan tulee sosiaali- ja terveydenhuollon
            työntekijöiltä sekä alle kouluikäisten lasten hoitotehtävissä työskenteleviltä vaatia
            ennen työhön ryhtymistä luotettava selvitys, ettei tämä sairasta hengityselinten tuberkuloosia.
            Selvitys on vaadittava myös harjoittelijoilta ja muilta vastaavilta henkilöiltä, jotka toimivat
            työpaikalla ilman palvelussuhdetta.
            <br><br>
            Selvitys tulee tehdä ennen uuden työtehtävän aloittamista, jos edellisestä tarkastuksesta on
            kulunut yli 2 vuotta.
            <br><br>
            Selvitys tehdään myös työsuhteen aikana, mikäli työntekijä on mahdollisesti altistunut tuberkuloosille
            esimerkiksi matkustaessaan alueella, jossa esiintyy paljon tuberkuloosia. Tämän
            vuoksi sinun on tärkeää ilmoittaa työnantajallesi, mikäli työsuhteesi aikana altistut mahdollisesti
            tuberkuloosille. On myös tärkeää, että otat aina yhteyttä lääkäriin, mikäli sinulla esiintyy
            yli 3 viikkoa jatkunutta yskää tai limannousua keuhkoista.</p>
        </span>
        <span class="introText">
          <h4 class="introTextTitle">Ennen kuin aloitat kyselyn...</h4>
          <p style="line-height: 2rem; font-size: 1.3rem;">Tämä kysely on osa tätä lakisääteistä selvitystä, ja tehdään sinun ja lähipiirin terveyden
            edistämiseksi sekä tartuttavan taudin leviämisen ehkäisemiseksi. Työnantajalla on oikeus
            käsitellä henkilön terveydentilaa koskevia tietoja tämän suostumuksella yksityisyyden suojasta
            työelämässä annetun lain, työterveyshuoltolain ja tietosuojalain mukaisesti. Vastaukset
            ovat salassa pidettäviä. Mikäli et halua vastata tähän kyselyyn, voit hankkia todistuksen
            tuberkuloositilanteestasi työterveyshuollosta, terveyskeskuksesta tai yksityiseltä lääkäriasemalta
            ja toimittaa sen työnantajallesi ennen töiden aloittamista.
            <br><br>
            Pyydämme sinua vastaamaan tähän terveyskyselyyn. Kyselyn lopussa olevasta linkistä saat
            lisätietoa tuberkuloosista.</p>
          <b-button variant="primary" style="margin-top: 2vh; margin-bottom: 4vh;" @click="start">Aloita kysely</b-button>
        </span>
      </div>
      <div id="questionnaire" class="questionnaire" style="display: none; align-items: center;">
        <h1 id="title" class="title" style="text-align: center;">Kysymykset</h1>
        <div class="questions">
          <div v-for="(question, index) in questions" :id="`question${index}`" class="question" :style="{ zIndex: questions.length - index }">
            <h5 class="questionTitle">{{ `${index + 1}. ${question.q}` }}</h5>
            <v-select
              v-if="question.type === 'select' || question.type === 'select_multiple'"
              v-model="questions[index].a"
              :options="question.options"
              :clearable="question.type === 'select_multiple'"
              :multiple="question.type === 'select_multiple'"
              style="width: 66%;"
              @input="checkQuestions"
            />
            <div
              v-if="question.type === 'checkbox'"
              style="display: flex; flex-direction: row;"
            >
              <b-form-checkbox
                v-model="questions[index].a"
                style="margin-right: 5px;"
                switch
                @input="risk = questions[index].a"
              />
              <p>{{ questions[index].a ? 'Kyllä' : 'En' }}</p>
            </div>
          </div>
        </div>
      </div>
      <div id="completedContainer" class="completedContainer" style="display: none;">
        <p v-if="risk" style="text-align: center; align-self: center; margin-top: 20vh; font-size: 1.5rem; line-height: 2.5rem;">Vastauksiesi perusteella voimme päätellä, että <b>sinulla on tarvetta käydä jatkotutkimuksissa</b> tuberkuloosiin liittyen. Olethan meihin yhteydessä sähköpostitse <b>info@hoiwa.fi</b>, niin ohjeistamme sinua asian kanssa :)</p>
        <p v-else style="text-align: center; align-self: center; margin-top: 20vh; font-size: 1.5rem; line-height: 2.5rem;">Vastauksiesi perusteella voimme päätellä, että <b>sinulla ei ole tarvetta käydä jatkotutkimuksissa</b> tuberkuloosiin liittyen. Voit nyt varata keikkoja Hoiwa-sovelluksesta vapaasti :)</p>
      </div>
      <b-button
        v-if="questionnaireStatus === 'pending_send'"
        variant="primary"
        class="submitBtn"
        @click="handleSubmit"
      >
        Lähetä vastaukset
      </b-button>
    </div>
    <div class="footer">
      <div style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
        <span class="imgContainer">
          <b-img
            src="https://thl.fi/o/thl-liferay-theme/images/thl_common/thl-logo-fi.png"
            alt="THL logo"
            class="img1"
          />
        </span>
        <span class="imgContainer">
          <b-img
            src="https://d1khyes0er28l5.cloudfront.net/images/logo-compact.png"
            alt="Vantaan kaupunki logo"
            class="img2"
          />
        </span>
        <span class="imgContainer">
          <b-img
            src="https://www.terveystalo.com/Static/assets/Terveystalo_RGB_2021.svg"
            alt="Terveystalo logo"
            class="img3"
          />
        </span>
        <span class="imgContainer">
          <b-img
            src="https://www.filha.fi/wp-content/uploads/2019/03/cropped-cropped-Filha-logo-2.png"
            alt="Filha logo"
            class="img4"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import {BNavbar, BImg, BButton, BFormCheckbox} from 'bootstrap-vue'
  import vSelect from 'vue-select'
  import Locale from '@hw-ui/layouts/components/navigation/navbar-top/components/Locale.vue'
  import { $themeConfig } from '@theme-config'
  import { functions } from '@/shared/services/firebase'
  import axios from '@hw-core/libs/axios'

  if (navigator.userAgent.indexOf('iPhone') > -1 ) {
    document
      .querySelector("[name=viewport]")
      .setAttribute("content","width=device-width, initial-scale=1, maximum-scale=1")
  }

  const countries = [
    "Afganistan",
    "Alankomaat",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua ja Barbuda",
    "Argentiina",
    "Armenia",
    "Australia",
    "Azerbaidžan",
    "Bahama",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belgia",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia-Hertsegovina",
    "Botswana",
    "Brasilia",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Chile",
    "Cookinsaaret",
    "Costa Rica",
    "Djibouti",
    "Dominica",
    "Dominikaaninen tasavalta",
    "Ecuador",
    "Egypti",
    "El Salvador",
    "Eritrea",
    "Espanja",
    "Eswatini",
    "Etelä-Afrikka",
    "Etelä-Korea",
    "Etelä-Sudan",
    "Etiopia",
    "Fidzi",
    "Filippiinit",
    "Gabon",
    "Gambia",
    "Georgia",
    "Ghana",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Indonesia",
    "Intia",
    "Irak",
    "Iran",
    "Irlanti",
    "Islanti",
    "Iso-Britannia",
    "Israel",
    "Italia",
    "Itä-Timor",
    "Itävalta",
    "Jamaika",
    "Japani",
    "Jemen",
    "Jordania",
    "Kambodža",
    "Kamerun",
    "Kanada",
    "Kap Verde",
    "Kazakstan",
    "Kenia",
    "Keski-Afrikan tasavalta",
    "Kiina",
    "Kirgisia",
    "Kiribati",
    "Kolumbia",
    "Komorit",
    "Kongon demokraattinen tasavalta",
    "Kongon tasavalta",
    "Kosovo",
    "Kreikka",
    "Kroatia",
    "Kuuba",
    "Kuwait",
    "Kypros",
    "Laos",
    "Latvia",
    "Lesotho",
    "Libanon",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Liettua",
    "Luxemburg",
    "Länsi-Sahara",
    "Madagaskar",
    "Malawi",
    "Malediivit",
    "Malesia",
    "Mali",
    "Malta",
    "Marokko",
    "Marshallinsaaret",
    "Mauritania",
    "Mauritius",
    "Meksiko",
    "Mikronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Mosambik",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norja",
    "Norsunluurannikko",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestiina",
    "Panama",
    "Papua-Uusi-Guinea",
    "Paraguay",
    "Peru",
    "Pohjois-Korea",
    "Pohjois-Makedonia",
    "Portugali",
    "Puola",
    "Päiväntasaajan Guinea",
    "Qatar",
    "Ranska",
    "Romania",
    "Ruanda",
    "Ruotsi",
    "Saint Kitts ja Nevis",
    "Saint Lucia",
    "Saint Vincent ja Grenadiinit",
    "Saksa",
    "Salomonsaaret",
    "Sambia",
    "Samoa",
    "San Marino",
    "Sao Tome ja Principe",
    "Saudi-Arabia",
    "Senegal",
    "Serbia",
    "Seychellit",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Somalia",
    "Sri Lanka",
    "Sudan",
    "Suomi",
    "Suriname",
    "Sveitsi",
    "Syyria",
    "Tadžikistan",
    "Taiwan (Kiinan tasavalta)",
    "Tansania",
    "Tanska",
    "Thaimaa",
    "Togo",
    "Tonga",
    "Trinidad ja Tobago",
    "Tunisia",
    "Turkki",
    "Turkmenistan",
    "Tuvalu",
    "Tšad",
    "Tšekki",
    "Uganda",
    "Ukraina",
    "Unkari",
    "Uruguay",
    "Uusi-Seelanti",
    "Uzbekistan",
    "Valko-Venäjä",
    "Vanuatu",
    "Vatikaani",
    "Venezuela",
    "Venäjä",
    "Vietnam",
    "Viro",
    "Yhdistyneet arabiemiirikunnat",
    "Yhdysvallat",
    "Zimbabwe",
  ]

  const riskCountries = [
    "Algeria",
    "Angola",
    "Benin",
    "Botswana",
    "Burkina Faso",
    "Burundi",
    "Djibouti",
    "Egypti",
    "Eritrea",
    "Eswatini",
    "Ethiopia",
    "Gabon",
    "Gambia",
    "Ghana",
    "Guinea",
    "Guinea-Bissau",
    "Kenia",
    "Lesotho",
    "Liberia",
    "Libya",
    "Madagaskar",
    "Malawi",
    "Mali",
    "Mauritania",
    "Mauritius",
    "Marokko",
    "Mozambique",
    "Namibia",
    "Niger",
    "Nigeria",
    "Rwanda",
    "Sao Tome ja Principe",
    "Senegal",
    "Seychellit",
    "Sierra Leone",
    "Somalia",
    "Etelä-Afrikka",
    "Etelä-Sudan",
    "Sudan",
    "Tansania",
    "Togo",
    "Tunisia",
    "Uganda",
    "Zambia",
    "Zimbabwe",
    "Afganistan",
    "Armenia",
    "Azerbaidžan",
    "Bahrain",
    "Bangladesh",
    "Bhutan",
    "Brunei",
    "Kambodža",
    "Kiina",
    "Georgia",
    "Indonesia",
    "Intia",
    "Irak",
    "Iran",
    "Israel",
    "Itä-Timor",
    "Japani",
    "Jemen",
    "Jordania",
    "Kazakstan",
    "Kirgisia",
    "Kiribati",
    "Kuwait",
    "Kypros",
    "Laos",
    "Libanon",
    "Malediivit",
    "Malesia",
    "Mongolia",
    "Myanmar",
    "Nepal",
    "Oman",
    "Pakistan",
    "Palestiina",
    "Qatar",
    "Saudi-Arabia",
    "Singapore",
    "Sri Lanka",
    "Syyria",
    "Tadžikistan",
    "Taiwan (Kiinan tasavalta)",
    "Thaimaa",
    "Turkki",
    "Turkmenistan",
    "Uzbekistan",
    "Vietnam",
    "Moldova",
    "Romania",
    "Ukraina",
    "Valko-Venäjä",
    "Venäjä"
  ]

  export default {
    components: {
      BNavbar,
      BImg,
      BButton,
      BFormCheckbox,
      vSelect,
      Locale,
    },
    data() {
      return {
        appLogoImage: $themeConfig.app.appLogoImage,
        title: 'Tervetuloa tuberkuloosikyselyyn!',
        questionnaireStatus: 'pending_start',
        risk: false,
        questions: [
          {
            q: 'Missä maassa olet syntynyt?',
            a: null,
            type: 'select',
            options: countries,
          },
          {
            q: 'Missä maassa tai maissa olet asunut vähintään 12 kuukauden ajan?',
            a: null,
            type: 'select_multiple',
            options: countries,
          },
          {
            q: 'Missä maassa tai maissa olet työskennellyt terveydenhuollossa vähintään 3 kuukauden ajan?',
            a: null,
            type: 'select_multiple',
            options: countries,
          },
          {
            q: 'Oletko hoitanut tuberkuloosipotilaita?',
            a: false,
            type: 'checkbox',
          },
          {
            q: 'Oletko ollut lähikontaktissa henkilöön, jolla on keuhkotuberkuloosi (esim. samassa taloudessa asuvat, sukulaiset, ystävät, työkaverit)?',
            a: false,
            type: 'checkbox',
          },
          {
            q: 'Oletko sairastanut tuberkuloosin?',
            a: false,
            type: 'checkbox',
          },
        ],
      }
    },
    methods: {
      start() {
        document.getElementById('introContainer').className = 'introContainer fadeOut'
        document.getElementById('title').className = 'title fadeOut'
        setTimeout(() => {
          document.getElementById('questionnaire').style = {display: 'block'}
          document.getElementById('questionnaire').className = 'questionnaire fadeIn'
        }, 1000)
        this.questionnaireStatus = 'in_progress'
        setTimeout(() => {
          document.getElementById('question0').className = 'question fadeIn'
        }, 1200)
        setTimeout(() => {
          document.getElementById('question1').className = 'question fadeIn'
        }, 1400)
        setTimeout(() => {
          document.getElementById('question2').className = 'question fadeIn'
        }, 1600)
        setTimeout(() => {
          document.getElementById('question3').className = 'question fadeIn'
        }, 1800)
        setTimeout(() => {
          document.getElementById('question4').className = 'question fadeIn'
        }, 2000)
        setTimeout(() => {
          document.getElementById('question5').className = 'question fadeIn'
        }, 2200)
      },
      checkQuestions() {
        if (!this.questions.some(question => question.a === null)) {
          this.questionnaireStatus = 'pending_send'
        }
      },
      async handleSubmit() {
        if (riskCountries.includes(this.questions[0].a)) {
          this.risk = true
        }
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < 2; i++) {
          // eslint-disable-next-line no-restricted-syntax
          for (const item of this.questions[i + 1].a) {
            if (riskCountries.includes(item)) {
              this.risk = true
            }
          }
        }

        this.questionnaireStatus = 'sent'
        document.getElementById('questionnaire').className = 'questionnaire fadeOut'
        this.title = 'Kiitos vastauksista!'
        setTimeout(() => {
          document.getElementById('title').className = 'title fadeIn'
          document.getElementById('completedContainer').style = {display: 'flex'}
          document.getElementById('completedContainer').className = 'completedContainer fadeIn'
        }, 1000)

        await axios.post(`${functions.url}/updateUserTBSurvey`, { id: this.$route.params.id, risk: this.risk })
      },
    },
  }
</script>

<style lang="scss">
  @import '@hw-ui/scss/vue/libs/vue-select.scss';

  .navbar {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .logo {
    img {
      width: 2.8rem;
    }
  }
  .logo2 {
    img {
      width: 6rem;
    }
  }
  .x {
    margin-inline: 20px;
    font-size: 1.4rem;
    font-weight: 100;
  }
  .introContainer {
    opacity: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-inline: 3vw;
    margin-top: 5vh;
  }
  .introTextTitle {
    margin-bottom: 2vh;
    margin-top: 4vh;
  }
  .introText {
    text-align: center;
  }
  .title {
    opacity: 1;
  }
  .questionnaire {
    opacity: 0;
  }
  .footer {
    display: flex;
    flex-direction: column;
    margin-top: 4vh;
    padding-block: 1vh;
    position: fixed;
    bottom: 0;
    width: 100vw;
    background-color: rgba(255, 255, 255, 1);
    align-items: center;
  }
  .imgContainer {
    margin-inline: 2vw;
  }
  .img1 {
    width: 9rem;
  }
  .img2 {
    width: 3rem;
  }
  .img3 {
    width: 5rem;
  }
  .img4 {
    width: 2rem;
  }
  .questions {
    padding-inline: 3vw;
  }
  .question {
    background-color: white;
    border-radius: 1rem;
    padding: 1rem;
    margin-block: 3vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    opacity: 0;
    position: relative;
  }
  .questionTitle {
    margin-bottom: 2vh;
    text-align: center;
  }
  .submitBtn {
    width: 50vw;
    align-self: center;
  }
  .completedContainer {
    opacity: 0;
    flex-direction: column;
    padding-inline: 20vw;
    margin-top: -15vh;
  }

  @media screen and (min-width: 768px) {
    .logo {
      img {
        width: 4rem;
      }
    }
    .logo2 {
      img {
        width: 10rem;
      }
    }
    .x {
      font-size: 2rem;
    }
    .introContainer {
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      padding-inline: 2vw;
    }
    .introTextTitle {
      margin-top: 0;
    }
    .introText {
      max-width: 45vw;
      min-height: 60vh;
      text-align: left;
    }
    .questions {
      display: grid;
      gap: 10% 2%;
      grid-template-columns: 32% 32% 32%;
      padding-inline: 2%;
      margin-top: 5vh;
    }
    .question {
      margin-block: 0;
    }
    .submitBtn {
      margin-top: 8vh;
      width: 30vw;
    }
  }

  @media screen and (min-width: 1600px) {
    .question {
      background-color: white;
      border-radius: 1rem;
      height: 16vh;
      padding: 2rem;
      opacity: 0;
    }
    .completedContainer {
      opacity: 0;
      flex-direction: column;
      align-items: center;
    }
    .imgContainer {
      margin-inline: 5vw;
    }
    .img1 {
      width: 13rem;
    }
    .img2 {
      width: 5rem;
    }
    .img3 {
      width: 8rem;
    }
    .img4 {
      width: 4rem;
    }
    .questions {
      margin-top: 10vh;
    }
    .question {
      padding: 2rem;
      margin-block: 2vh;
      align-items: flex-start;
      opacity: 0;
    }
    .questionTitle {
      text-align: left;
    }
    .submitBtn {
      width: 20vw;
    }
  }

  .fadeIn {
    animation: fadeIn 1s linear forwards;
  }
  .fadeOut {
    animation: fadeOut 1s linear forwards;
  }

  @keyframes fadeIn {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }
  @keyframes fadeOut {
    0% { opacity: 1; }
    100% { opacity: 0; display: none; }
  }
</style>